// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "shipbob_user_management_ui_styles" + "." + "93d45048" + ".chunk.css";
};